import AdministrationTemplate from './AdministrationTemplate'

export default AdministrationTemplate
